module.exports = "/lucky-balls/img/drum/drum_loop_032.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_032.png
// module id = 1047
// module chunks = 0